export const isFlagEnabled = (goLiveDate: string): boolean => {
  return Date.now() >= Date.parse(goLiveDate);
};
